import { render, staticRenderFns } from "./Goodsclass.vue?vue&type=template&id=4dedce26&scoped=true"
import script from "./Goodsclass.vue?vue&type=script&lang=js"
export * from "./Goodsclass.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dedce26",
  null
  
)

export default component.exports